import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useLang } from "@/App";
import { legal } from "@/lib/legal";
import Nav from "@/components/Nav";
import LegalFooter from "@/components/LegalFooter";

export default function LegalPage() {
  const { slug } = useParams();
  const nav = useNavigate();
  const { lang } = useLang();
  const L = legal[lang];
  const data = L[slug]; // "privacy" | "terms" | "cookies"

  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="legal-not-found">
        <div className="text-center">
          <h1 className="serif text-3xl mb-4">{lang === "ro" ? "Pagină negăsită" : "Page not found"}</h1>
          <button onClick={() => nav("/")} className="btn-pill btn-dark">← Home</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" data-testid={`legal-page-${slug}`}>
      <Nav />
      <main className="pt-32 pb-20" style={{ background: "#fbf8f1" }}>
        <div className="container-x" style={{ maxWidth: 820 }}>
          <button onClick={() => nav("/")} className="text-xs uppercase tracking-widest mb-8" style={{ color: "var(--olive-deep)" }} data-testid="legal-back">
            ← {lang === "ro" ? "Înapoi acasă" : "Back home"}
          </button>
          <div className="eyebrow mb-3">{L.sections.legal}</div>
          <h1 className="h-display mb-2" style={{ fontSize: "clamp(36px, 5vw, 60px)" }}>{data.title}</h1>
          <p className="text-sm mb-12" style={{ color: "var(--ink-muted)" }}>{data.updated}</p>

          <article className="space-y-8">
            {data.sections.map((s, i) => (
              <section key={i} data-testid={`legal-section-${i}`}>
                <h2 className="serif mb-3" style={{ fontSize: 22, color: "var(--ink)" }}>{s.h}</h2>
                <p style={{ color: "var(--ink-soft)", lineHeight: 1.75, fontSize: 15 }}>{s.p}</p>
              </section>
            ))}
          </article>
        </div>
      </main>
      <LegalFooter />
    </div>
  );
}
